export default {
  path: '/ehr',
  name: 'ehr',
  component: () => import('@/views/Ehr.vue'),
  children: [
    {
      path: 'approval',
      name: 'ehrApproval',
      component: () => import('@/components/ehr/Nav.vue'),
      meta: {
        title: 'ehr审批'
      }
    },
    {
      path: 'card',
      name: 'card',
      component: () => import('@/components/ehr/Ehr.vue'),
      redirect: 'card/upcoming/details',
      children:[
        {
          path: 'upcoming/details',
          name: 'cardDetails',
          component: () => import('@/components/ehr/card/Details.vue'),
          meta: {
            title: '名片申请单'
          }
        },
        {
          path: 'completed/details',
          name: 'cardCompletedDetails',
          component: () => import('@/components/ehr/card/DoneDetails.vue'),
          meta: {
            title: '名片申请单'
          }
        },
        {
          path: 'record',
          name: 'cardRecord',
          component: () => import('@/components/ehr/card/Record.vue'),
          meta: {
            title: '审批记录'
          }
        },
        {
          path: 'system',
          name: 'system',
          component: () => import('@/components/ehr/card/System.vue'),
          meta: {
            title: '相关制度说明'
          }
        }
      ]
    },
    {
      path: 'personal',
      name: 'personal',
      component: () => import('@/components/ehr/Ehr.vue'),
      redirect: 'personal/upcoming/details',
      children:[
        {
          path: 'upcoming/details',
          name: 'personalDetails',
          component: () => import('@/components/ehr/personal/Details.vue'),
          meta: {
            title: '员工个人信息修改申请单'
          },
        },
        {
          path: 'completed/details',
          name: 'personalCompletedDetails',
          component: () => import('@/components/ehr/personal/DoneDetails.vue'),
          meta: {
            title: '员工个人信息修改申请单'
          }
        },
        {
          path: 'record',
          name: 'personalRecord',
          component: () => import('@/components/ehr/personal/Record.vue'),
          meta: {
            title: '审批记录'
          }
        }
      ]
    }
  ]
}
